import { render, staticRenderFns } from "./AllEvents.vue?vue&type=template&id=4741ada4&scoped=true&"
import script from "./AllEvents.vue?vue&type=script&lang=js&"
export * from "./AllEvents.vue?vue&type=script&lang=js&"
import style0 from "./AllEvents.vue?vue&type=style&index=0&id=4741ada4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4741ada4",
  null
  
)

export default component.exports